export const ENRICHING_ACTIVITIES: string[] = [
  'Aprender a cocinar',
  'Aprender a jugar ajedrez',
  'Aprender un idioma por gusto',
  'Aprender a tocar un instrumento',
  'Clases de dibujo o pintura',
  'Salir a pasear con mascota',
  'Hacer jardinería',
];
